import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { Trans, useTranslation } from "@coworker/locales";
import profilePreferences from "@coworker/enums/profilePreferences";
import Instructions from "../../Instructions";
import { useInputPopup } from "../../InputPopup";
import ExpeditTag from "../../../assets/svg/EXPEDIT-tag.svg?react";
import SupplierNumberMarker from "../../../assets/svg/supplier-number-marker.svg?react";
import { Article, ArticleSupplierNumberResponse } from "../types/article";
import { Text } from "../Atoms/Text";
import { Overlay } from "../styles/styles";
import { useUpdateArticle } from "../hooks/useUpdateArticle";

const { DISABLE_POPUPS_SUPPLIER_NUMBER } = profilePreferences;

interface SupplierNumberProps {
  article: Article;
  value: string;
}

export const SupplierNumber = ({ article, value }: SupplierNumberProps) => {
  const { t } = useTranslation();
  const { getInput } = useInputPopup();
  const updateArticle = useUpdateArticle(article.id);

  const getSupplierNumber = async () => {
    const response: ArticleSupplierNumberResponse = await getInput(
      "supplierNumber",
      {
        value,
        bigTitle: <Trans>supplierNumberString</Trans>,
        instruction: (
          <Instructions
            title={<Trans>whereCanIfindSupplierString</Trans>}
            text={
              <Overlay minHeight="133px">
                <ExpeditTag />
                <SupplierNumberMarker />
              </Overlay>
            }
            type={DISABLE_POPUPS_SUPPLIER_NUMBER}
          />
        ),
      }
    );
    if (response) {
      try {
        await updateArticle.mutateAsync({
          supplierNumber: response.supplier_number,
        });
      } catch {
        alert(t("searchErrorString"));
      }
    }
  };

  const addOnContent = value ? <Text text={value} grey /> : "";

  return (
    <FixaListViewItem
      title={t("supplierNumberString")}
      addOn={addOnContent}
      control={"navigational"}
      controlIcon={"chevronRightSmall"}
      onClick={getSupplierNumber}
      emphasised
      inset
    />
  );
};
